import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _70826802 = () => interopDefault(import('../../../pages/enem/enem-digital.vue' /* webpackChunkName: "pages/enem/enem-digital" */))
const _2710c635 = () => interopDefault(import('../../../pages/enem/manual-do-enem/index.vue' /* webpackChunkName: "pages/enem/manual-do-enem/index" */))
const _e627cbae = () => interopDefault(import('../../../pages/fies/aditamento-renovacao.vue' /* webpackChunkName: "pages/fies/aditamento-renovacao" */))
const _3eabfde6 = () => interopDefault(import('../../../pages/fies/como-funciona.vue' /* webpackChunkName: "pages/fies/como-funciona" */))
const _09d1b789 = () => interopDefault(import('../../../pages/fies/como-se-inscrever.vue' /* webpackChunkName: "pages/fies/como-se-inscrever" */))
const _631b348e = () => interopDefault(import('../../../pages/fies/o-que-e-quem-pode.vue' /* webpackChunkName: "pages/fies/o-que-e-quem-pode" */))
const _35736c7b = () => interopDefault(import('../../../pages/prouni/como-se-inscrever.vue' /* webpackChunkName: "pages/prouni/como-se-inscrever" */))
const _f91397ae = () => interopDefault(import('../../../pages/prouni/documentos-necessarios.vue' /* webpackChunkName: "pages/prouni/documentos-necessarios" */))
const _a5bc9b20 = () => interopDefault(import('../../../pages/prouni/lista-de-espera.vue' /* webpackChunkName: "pages/prouni/lista-de-espera" */))
const _0bd7caaa = () => interopDefault(import('../../../pages/prouni/o-que-e-quem-pode.vue' /* webpackChunkName: "pages/prouni/o-que-e-quem-pode" */))
const _7b0fd1bc = () => interopDefault(import('../../../pages/prouni/universidades-participantes.vue' /* webpackChunkName: "pages/prouni/universidades-participantes" */))
const _7e53f2d0 = () => interopDefault(import('../../../pages/sisu/como-se-inscrever.vue' /* webpackChunkName: "pages/sisu/como-se-inscrever" */))
const _77a9ca05 = () => interopDefault(import('../../../pages/sisu/lista-de-espera.vue' /* webpackChunkName: "pages/sisu/lista-de-espera" */))
const _42f4a100 = () => interopDefault(import('../../../pages/sisu/o-que-e-quem-pode.vue' /* webpackChunkName: "pages/sisu/o-que-e-quem-pode" */))
const _517031d1 = () => interopDefault(import('../../../pages/sisu/universidades-participantes.vue' /* webpackChunkName: "pages/sisu/universidades-participantes" */))
const _ae28bb2c = () => interopDefault(import('../../../pages/enem/_category/index.vue' /* webpackChunkName: "pages/enem/_category/index" */))
const _33d450b2 = () => interopDefault(import('../../../pages/enem/_category/_lesson/index.vue' /* webpackChunkName: "pages/enem/_category/_lesson/index" */))
const _45ff13b4 = () => interopDefault(import('../../../pages/_home.vue' /* webpackChunkName: "pages/_home" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/enem/enem-digital",
    component: _70826802,
    name: "enem-enem-digital"
  }, {
    path: "/enem/manual-do-enem",
    component: _2710c635,
    name: "enem-manual-do-enem"
  }, {
    path: "/fies/aditamento-renovacao",
    component: _e627cbae,
    name: "fies-aditamento-renovacao"
  }, {
    path: "/fies/como-funciona",
    component: _3eabfde6,
    name: "fies-como-funciona"
  }, {
    path: "/fies/como-se-inscrever",
    component: _09d1b789,
    name: "fies-como-se-inscrever"
  }, {
    path: "/fies/o-que-e-quem-pode",
    component: _631b348e,
    name: "fies-o-que-e-quem-pode"
  }, {
    path: "/prouni/como-se-inscrever",
    component: _35736c7b,
    name: "prouni-como-se-inscrever"
  }, {
    path: "/prouni/documentos-necessarios",
    component: _f91397ae,
    name: "prouni-documentos-necessarios"
  }, {
    path: "/prouni/lista-de-espera",
    component: _a5bc9b20,
    name: "prouni-lista-de-espera"
  }, {
    path: "/prouni/o-que-e-quem-pode",
    component: _0bd7caaa,
    name: "prouni-o-que-e-quem-pode"
  }, {
    path: "/prouni/universidades-participantes",
    component: _7b0fd1bc,
    name: "prouni-universidades-participantes"
  }, {
    path: "/sisu/como-se-inscrever",
    component: _7e53f2d0,
    name: "sisu-como-se-inscrever"
  }, {
    path: "/sisu/lista-de-espera",
    component: _77a9ca05,
    name: "sisu-lista-de-espera"
  }, {
    path: "/sisu/o-que-e-quem-pode",
    component: _42f4a100,
    name: "sisu-o-que-e-quem-pode"
  }, {
    path: "/sisu/universidades-participantes",
    component: _517031d1,
    name: "sisu-universidades-participantes"
  }, {
    path: "/enem/:category",
    component: _ae28bb2c,
    name: "enem-category"
  }, {
    path: "/enem/:category?/:lesson",
    component: _33d450b2,
    name: "enem-category-lesson"
  }, {
    path: "/:home?",
    component: _45ff13b4,
    name: "home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
